import httpClient from "@/_shared/http-client";
import urlBuilder from "@/stock/api-services/_urlBuilder";
import { pagination } from '@/_shared/utils';

const getAll = async(filters) => {
  let results = [];
  let pagesCounter = 1;
  const url = urlBuilder.buildForStockMovementPage(filters);
  await httpClient.get(url).then(({ data }) => {
    pagesCounter = pagination.getPagesCounter(data.results);
    results = data.records
  });;
  return { results, pagesCounter };
}

export const stockOperationsService = { getAll };



// WEBPACK FOOTER //
// ./src/stock/api-services/stockOperationsService.js